module.exports = __webpack_public_path__ + "static/media/valor2.a671a6b3.png";